import axios, { AxiosError } from "axios";

function requestTarget(err: AxiosError): string {
    const base = err.config?.baseURL?.replace(/\/$/, "") ?? "";
    const path = (err.config?.url ?? "").replace(/^\//, "");
    if (!base) return path || "API server";
    return path ? `${base}/${path}` : base;
}

function isNetworkError(err: AxiosError): boolean {
    if (err.response) return false;
    const code = err.code ?? "";
    return (
        code === "ECONNREFUSED" ||
        code === "ENOTFOUND" ||
        code === "ERR_NETWORK" ||
        err.message === "Network Error"
    );
}

function campaignApiUnreachableMessage(target: string): string {
    const local = process.env.NEXT_PUBLIC_LOCAL_CAMPAIGN_BLOG_URL?.trim().replace(/\/$/, "");
    let port = "3020";
    if (local) {
        try {
            port = new URL(local).port || port;
        } catch {
            /* keep default */
        }
    }
    return `Campaign API unreachable at ${target} — start nest-campaign-blog on port ${port} (npm run local:api:env)`;
}

/**
 * Helper for error extraction
 */
const handleApiError = (error: unknown): string => {
    if (axios.isAxiosError(error)) {
        const err = error as AxiosError<{ message?: string }>;
        if (err.response?.data?.message) {
            return err.response.data.message;
        }
        if (isNetworkError(err)) {
            const target = requestTarget(err);
            const path = err.config?.url ?? "";
            const local = process.env.NEXT_PUBLIC_LOCAL_CAMPAIGN_BLOG_URL?.trim().replace(/\/$/, "");
            const base = err.config?.baseURL?.replace(/\/$/, "") ?? "";
            const isCampaignApi =
                Boolean(local && base.startsWith(local)) ||
                /marketing-campaigns|cms-blog-templates/.test(path);
            if (isCampaignApi) {
                return campaignApiUnreachableMessage(target);
            }
            const code = err.code ? ` (${err.code})` : "";
            return `Network error: unable to reach ${target}${code}`;
        }
        return err.message;
    }
    return "Unknown error occurred";
};

export default handleApiError;